(function() {
  function formatDate(date) {
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  }

  function renderTimelineDates() {
    var today = new Date();
    document.querySelectorAll('[data-hj-date]').forEach(function(el) {
      var type = el.dataset.hjDate;
      var date;
      if (type === 'today') {
        date = today;
      } else if (type === 'tomorrow') {
        date = new Date(today);
        date.setDate(today.getDate() + 1);
      } else if (type === 'arrive') {
        var days = parseInt(el.dataset.hjDays || '5', 10);
        date = new Date(today);
        date.setDate(today.getDate() + days);
      } else {
        return;
      }
      el.textContent = formatDate(date);
    });
  }

  function setDeadlineValue(root, name, value) {
    root.querySelectorAll('[data-hj-deadline-' + name + ']').forEach(function(el) {
      el.textContent = String(value).padStart(2, '0');
    });
  }

  function toggleDeadlineState(root, state) {
    ['active', 'expired', 'invalid'].forEach(function(name) {
      root.querySelectorAll('[data-hj-deadline-' + name + ']').forEach(function(el) {
        el.hidden = name !== state;
      });
    });
    root.dataset.hjDeadlineState = state;
  }

  function initDeadline(root) {
    var deadline = new Date(root.dataset.hjCampaignDeadline || '');
    if (Number.isNaN(deadline.getTime())) {
      toggleDeadlineState(root, 'invalid');
      return;
    }

    function update() {
      var difference = deadline.getTime() - Date.now();
      if (difference <= 0) {
        setDeadlineValue(root, 'days', 0);
        setDeadlineValue(root, 'hours', 0);
        setDeadlineValue(root, 'minutes', 0);
        toggleDeadlineState(root, 'expired');
        return false;
      }

      var totalMinutes = Math.floor(difference / 60000);
      setDeadlineValue(root, 'days', Math.floor(totalMinutes / 1440));
      setDeadlineValue(root, 'hours', Math.floor((totalMinutes % 1440) / 60));
      setDeadlineValue(root, 'minutes', totalMinutes % 60);
      toggleDeadlineState(root, 'active');
      return true;
    }

    if (update()) {
      var timer = window.setInterval(function() {
        if (!document.documentElement.contains(root) || !update()) window.clearInterval(timer);
      }, 30000);
    }
  }

  function copyText(value) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(value);
    return new Promise(function(resolve, reject) {
      var input = document.createElement('textarea');
      input.value = value;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      try {
        if (!document.execCommand('copy')) throw new Error('Copy command failed');
        resolve();
      } catch (error) {
        reject(error);
      } finally {
        input.remove();
      }
    });
  }

  function bindCampaignTools() {
    document.querySelectorAll('[data-hj-campaign-deadline]').forEach(function(root) {
      if (root.dataset.hjDeadlineBound === 'true') return;
      root.dataset.hjDeadlineBound = 'true';
      initDeadline(root);
    });

    if (document.documentElement.dataset.hjCopyCodeBound === 'true') return;
    document.documentElement.dataset.hjCopyCodeBound = 'true';
    document.addEventListener('click', function(event) {
      var button = event.target.closest('[data-hj-copy-code]');
      if (!button) return;
      var status = button.parentElement && button.parentElement.querySelector('[data-hj-copy-status]');
      copyText(button.dataset.hjCopyCode || '').then(function() {
        if (status) status.textContent = button.dataset.hjCopyLabel || 'Code copied';
      }).catch(function() {
        if (status) status.textContent = 'Copy failed. Select the code and copy it manually.';
      });
    });
  }

  function init() {
    renderTimelineDates();
    bindCampaignTools();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', bindCampaignTools);
  document.addEventListener('havjoy:pdp-mounted', init);
})();
